import Bundle from './Bundle'

export default Bundle


// WEBPACK FOOTER //
// ./src/components/bundle/v1/index.jsx